import React, { Component, Fragment } from "react"
import Async from "react-select"
import modalIcon from "../../../assets/images/testIcon.svg"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import TimerModule from "../TimerModule"
import ButtonIcon from "../ButtonIcon"

import { DevelopmentServices, SampleServices } from "../../../services"
import { log } from "util"

const shirringTemplate = {
  trimCategory: "",
  trimRefNo: "",
  placement: "",
  type: "",
  noOfRows: "",
  length: "",
  total: ""
}

export default class SewingModule extends Component {
  state = {
    sewing: [],
    STATUS: [],
    PLACEOFSEWING: [],
    SEWINGTYPE: [],
    trimCategoryList: [],
    trimNumberList: [],
    assignedToList: [],
    sample: {},
    disabled: false
  }

  componentWillMount() {
    const {
      _id,
      sewing,
      disabled,
      STATUS,
      assignedToList,
      PLACEOFSEWING,
      SEWINGTYPE,
      sewingProcess,
      trimNumberList,
      TRIM,
      sample,
      TRIMPLACEMENT
    } = this.props

    let data = sample.data
    data = data.map(x => x.size && ({ label: x.size }) || 0)

    this.setState({
      _id,
      sewing,
      disabled,
      STATUS,
      assignedToList,
      PLACEOFSEWING,
      SEWINGTYPE,
      sewingProcess,
      trimNumberList,
      sample: data,
      TRIM,
      TRIMPLACEMENT
    })

  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      sewing,
      disabled,
      STATUS,
      assignedToList,
      PLACEOFSEWING,
      SEWINGTYPE,
      sewingProcess,
      trimNumberList,
      sample,
      TRIM,
      TRIMPLACEMENT
    } = nextProps
    let data = sample.data
    data = data.map(x => x.size && ({ label: x.size }) || 0)

    this.setState({
      _id,
      sewing,
      disabled,
      STATUS,
      assignedToList,
      PLACEOFSEWING,
      SEWINGTYPE,
      sewingProcess,
      sample: data,
      trimNumberList,
      TRIM,
      TRIMPLACEMENT
    })

    const { TAILORSNAME } = this.props.tailorName;
    this.setState({ assignedToList: TAILORSNAME })

  }

  render() {
    const {
      sewing,
      STATUS,
      assignedToList,
      PLACEOFSEWING,
      SEWINGTYPE, sample
    } = this.state
    const { permissions } = this.props;
    // let { data } = this.state.sample;
    // data = data.map(sample => {
    //   return {
    //     label: sample.size || 0
    //   }
    // }
    // )

    return (
      <div
        class="mt-5"
        id="sewing"
      // style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Sewing "}
            onClick={this.onOpenModal}
            _id={this.state._id}
            process={this.state.sewingProcess}
            updateModulesMain={this.props.updateModulesMain}
            placeOfSewing={sewing.placeOfSewing}
            PLACEOFSEWING={this.state.PLACEOFSEWING}
            updateSewing={this.props.updateSewing1}
            moduleName={"sewing"}
            disabled={this.state.disabled}
            statusList={STATUS}
          />
          <div class="col-md-12 no-padding" style={{ paddingBottom: "1%" }}>
            <form name="sewingForm">
              <div class="col-md-12 no-padding">
                <div className="col-md-12  no-padding">
                  <div className="inline-center" style={{ width: "7%" }}>
                    <label>Sewing</label>
                    {!this.state.disabled &&
                      (permissions.create || permissions.edit) && (
                        <ButtonIcon
                          buttonType="add"
                          addRemoveFunc={() => this.props.addSewing()}
                        />
                      )}
                  </div>
                </div>
                <Fragment>
                  {sewing.sewingData.map((value, index) => (
                    <Fragment key={index}>
                      <div class="col-md-12 nopadding">
                        <table class="costingtable">
                          <thead class="border-bottom-0">
                            <tr class="border-bottom-0">
                              <th class="border-bottom-0 text-left" width="10%">
                                Tailor name
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Sewing type
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Size
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Qty
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Approval Status
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="10%"
                              />
                              <th
                                class="border-bottom-0 text-left"
                                width="10%"
                              />
                            </tr>
                          </thead>
                          {/* {this.findSizes()} */}
                          <tbody>
                            <tr>
                              <td class="border-top-0 padding-top">
                                <div class="custom-async-select">
                                  <Async
                                    name="tailorName"
                                    value={value.tailorName}
                                    // onInputChange={this.getFabricNumber}
                                    onChange={value =>
                                      this.props.updateSewing(
                                        "tailorName",
                                        value,
                                        index
                                      )
                                    }
                                    placeholder="Tailor Name"
                                    options={this.state.assignedToList}
                                    disabled={this.state.disabled}
                                  />
                                </div>
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="sewingType"
                                  value={value.sewingType}
                                  options={this.state.SEWINGTYPE || []}
                                  index={index}
                                  onChange={this.props.updateSewing}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="size"
                                  value={value.size}
                                  index={index}
                                  options={sample}
                                  onChange={this.props.updateSewing}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="quantity"
                                  value={value.quantity}
                                  index={index}
                                  onChange={this.props.updateSewing}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="approvalStatus"
                                  value={value.approvalStatus}
                                  options={[
                                    {
                                      label: "approved",
                                      value: "approved"
                                    },
                                    {
                                      label: "pending",
                                      value: "pending"
                                    },
                                    {
                                      label: "rejected",
                                      value: "rejected"
                                    }
                                  ]}
                                  index={index}
                                  onChange={this.props.updateSewing}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                {value.approvalStatus == "rejected" && (
                                  <Field
                                    isFormGroup={false}
                                    inputType="text"
                                    inputName="rejected"
                                    value={value.rejected}
                                    index={index}
                                    onChange={this.props.updateSewing}
                                    disabled={this.state.disabled}
                                  />
                                )}
                              </td>
                              <td class="border-top-0">
                                {!this.state.disabled &&
                                  (permissions.create || permissions.edit) && (
                                    <ButtonIcon
                                      buttonType="clear"
                                      addRemoveFunc={() =>
                                        this.props.removeSewing(index)
                                      }
                                    />
                                  )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className=" col-md-12 padding-top">
                          <div
                            className="inline-center"
                            style={{ width: "7%" }}
                          >
                            <label>Logs</label>
                            {!this.state.disabled &&
                              (permissions.create || permissions.edit) && (
                                <ButtonIcon
                                  buttonType="add"
                                  addRemoveFunc={() =>
                                    this.props.addSewingLog(index)
                                  }
                                />
                              )}
                          </div>
                        </div>
                        {value.logs.map((log, i) => {
                          return (
                            <div class="col-md-12 no-padding" key={i}>
                              <TimerModule
                                time={log.timeIn}
                                buttonName={"time in"}
                                updatePatternCheck={() =>
                                  this.props.updateSewingCheck(
                                    "timeIn",
                                    i,
                                    index
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                              <TimerModule
                                time={log.timeOut}
                                buttonName={"time out"}
                                updatePatternCheck={() =>
                                  this.props.updateSewingCheck(
                                    "timeOut",
                                    i,
                                    index
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                              <div class="col-md-2 step-one pl-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="time"
                                  inputName="breakTime"
                                  label="Break Time (Duration)"
                                  value={log.breakTime}
                                  onChange={(name, value) =>
                                    this.props.updateSewingLog(
                                      name,
                                      value,
                                      i,
                                      index
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-2 step-one pl-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="reason"
                                  label="Reason"
                                  value={log.reason}
                                  onChange={(name, value) =>
                                    this.props.updateSewingLog(
                                      name,
                                      value,
                                      i,
                                      index
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-1 step-one pl-0">
                                {!this.state.disabled &&
                                  (permissions.create || permissions.edit) && (
                                    <ButtonIcon
                                      buttonType="clear"
                                      addRemoveFunc={() =>
                                        this.props.removeSewingLog(i, index)
                                      }
                                    />
                                  )}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </Fragment>
                  ))}

                  <div className={"col-md-12"}>
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="smokingOrShiring"
                      value={this.state.sewing.smokingOrShiring}
                      label="smocking/Shirring"
                      onChange={e => {
                        this.props.updateSewing1(e)
                      }}
                      disabled={this.state.disabled}
                      className={"p-0 col-1"}
                    />

                    {this.state.sewing.smokingOrShiring && (
                      <div class="col-md-12 nopadding">
                        <table class="table">
                          <thead class="border-bottom-0">
                            <tr class="border-bottom-0">
                              <th class="border-bottom-0 text-left" width="14%">
                                Trim Category
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Trim Ref no
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Placement
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Type
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                No Of Rows
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Length in cm
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              >
                                Total Reqrd-mtrs
                              </th>
                              <th
                                class="border-bottom-0 text-left"
                                width="11.1111111111%"
                              />
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.sewing.trimData && this.state.sewing.trimData.length && this.state.sewing.trimData.map((value, index) => (
                              <tr>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="trimCategory"
                                    value={
                                      index === 0 ? value.trimCategory : null
                                    }
                                    index={index}
                                    options={this.state.TRIM.TRIMCATEGORY || []}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <div class="custom-async-select">
                                    <Async
                                      // clearable={false}
                                      name="trimNumber"
                                      value={value.trimNumber}
                                      onInputChange={data =>
                                        this.props.getTrimRefNoSewing(
                                          value.trimCategory,
                                          data,
                                          index
                                        )
                                      }
                                      onChange={value =>
                                        this.props.getTrimInfoSewTrimData(
                                          value,
                                          index
                                        )
                                      }
                                      placeholder="Find trimRefNo"
                                      options={
                                        value.trimList ? value.trimList : []
                                      }
                                      disabled={this.state.disabled}
                                      onSelectResetsInput={false}
                                      onBlurResetsInput={false}
                                    />
                                  </div>
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="placement"
                                    value={value.placement}
                                    index={index}
                                    options={this.state.TRIMPLACEMENT || []}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="type"
                                    value={value.type}
                                    index={index}
                                    options={[
                                      {
                                        label: "Both Elastic",
                                        value: "Both Elastic"
                                      },
                                      {
                                        label: "Top TTH / Bottom Elastic",
                                        value: "Top TTH / Bottom Elastic"
                                      }
                                    ]}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="noOfRow"
                                    index={index}
                                    value={value.noOfRow}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="length"
                                    value={value.length}
                                    index={index}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="number"
                                    inputName="totalReq"
                                    value={value.totalReq}
                                    index={index}
                                    onChange={this.props.updateSewingTrimData}
                                    disabled={this.state.disabled || true}
                                  />
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ top: "12px" }}
                                >
                                  {!this.state.disabled &&
                                    (permissions.create ||
                                      permissions.edit) && (
                                      <a
                                        className={
                                          index === 0
                                            ? "btn-floating btn-small waves-effect waves-light green pull-right"
                                            : "btn-floating btn-small waves-effect waves-light red pull-right del-tr-btn"
                                        }
                                        onClick={e =>
                                          index === 0
                                            ? this.props.smockingShirringaddTrim()
                                            : this.props.smockingShirringremoveTrim(
                                              "row2",
                                              index
                                            )
                                        }
                                      >
                                        <i class="material-icons">
                                          {index === 0 ? "add" : "clear"}
                                        </i>
                                      </a>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  <div class="col-md-12 step-one nopadding">
                    <Field
                      isFormGroup={true}
                      inputType="textarea"
                      inputName="comments"
                      value={sewing.comments}
                      label="comments"
                      onChange={this.props.updateSewing1}
                      disabled={this.state.disabled}
                    />
                  </div>
                </Fragment>
              </div>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <div className="col-md-12 text-center profile-btn">
                    <Button
                      buttonType="save"
                      buttonName="save"
                      onClick={this.props.createSewing}
                    />
                    <Button
                      buttonType="save"
                      buttonName="Complete"
                      onClick={this.props.completeSewing}
                    />
                  </div>
                )}
            </form>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/SewingModule/index.js